/* eslint import/prefer-default-export: "off" */
export function isTrue(value: string) {
  return (value || '').toLowerCase() === 'true'
}
